import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-base-vertical-overlay',
  templateUrl: './base-vertical-overlay.component.html',
  styleUrls: ['./base-vertical-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseVerticalOverlayComponent {
  @Output()
  public closed = new EventEmitter();
}
